import { VisitorCard } from '@features/events/event-visitors/visitor-card';
import { formatPhoneNumber } from '@shared/helpers';
import { type TicketDetail } from '@src/library/models/events';
import st from './styles.module.scss';

interface Props {
  ticketsList: TicketDetail[];
  selectedTickets: TicketDetail[];
  isSelectionOn: boolean;
  onSelectedTicket: (ticket: TicketDetail) => void;
}

export const VisitorsList: React.FC<Props> = ({
  ticketsList,
  selectedTickets,
  isSelectionOn,
  onSelectedTicket,
}) => {
  return (
    <ul className={st.visitorList}>
      {ticketsList.map((ticket) => (
        <li key={ticket.id}>
          <VisitorCard
            fullNameVisitor={`${ticket.last_name ?? ''} ${ticket.first_name ?? ''} ${ticket.middle_name ?? ''}`}
            isPayed={ticket.is_payed}
            isSelected={selectedTickets.includes(ticket)}
            isSelectionOn={isSelectionOn}
            onSelected={() => onSelectedTicket(ticket)}
            phoneNumber={formatPhoneNumber(ticket.phone)}
            ticketId={ticket.id}
          />
        </li>
      ))}
    </ul>
  );
};
